export { default as Quotes } from "./Quotes";
export { default as QuoteDetails } from "./Details";
